<script>
  export let onClick;
  export let text;
</script>

<button
  on:click={onClick}
  class="w-full py-3 text-white rounded-md bg-gradient-to-r from-fcred to-white focus:outline-none hover:bg-gray-700 hover:shadow-none"
  >{text}</button
>
